import React from "react";
import { SelectUnitName } from "ts/App/Analytics/Common";
import { ILessonsChartsInfo, ITimeChartsInfo } from "ts/parsers/analytics";
import {
  UnitContainer,
  UnitChartGridContainer,
  UnitChartsNameContainer,
  UnitName,
  IndividualUnitChartContainer,
} from "./UnitsAnalytics.styles";
import { TimeChart } from "./TimeChart";
import { LessonsChart } from "./LessonsChart";

interface IUnitChartsProps {
  unitName: string;
  times: ITimeChartsInfo[];
  selectUnitName: SelectUnitName;
  lessons: ILessonsChartsInfo[];
  level: number;
  isFirst: boolean;
  maxStudents: number;
  maxAvgTime: number;
  isFilterActive?: boolean;
}

export const UnitCharts: React.FC<IUnitChartsProps> = ({
  unitName,
  times,
  selectUnitName,
  lessons,
  level,
  isFirst,
  maxStudents,
  maxAvgTime,
  isFilterActive,
}) => {
  return (
    <UnitContainer data-testid="unit-charts-container" onClick={selectUnitName(unitName)}>
      <UnitChartGridContainer>
        <UnitChartsNameContainer>
          <UnitName>
            {"• ".repeat(level)} {unitName}
          </UnitName>
        </UnitChartsNameContainer>
        <IndividualUnitChartContainer isFirst={isFirst}>
          <TimeChart times={times} showYAxis={isFirst} maxAvgTime={maxAvgTime} isFilterActive={isFilterActive} />
        </IndividualUnitChartContainer>
        <IndividualUnitChartContainer isFirst={isFirst}>
          <LessonsChart
            lessons={lessons}
            maxStudents={maxStudents}
            showXAxis={isFirst}
            isFilterActive={isFilterActive}
          />
        </IndividualUnitChartContainer>
      </UnitChartGridContainer>
    </UnitContainer>
  );
};
